import React from 'react';
import PropTypes from 'prop-types';

function FollowupAllButton(props) {
  const {
    buttonText,
    buttonClass,
    displayIcon,
    clickEvent,
    disabled,
  } = props;

  return (
    <button
      type="button"
      className={buttonClass}
      onClick={clickEvent}
      disabled={disabled}
    >
      {displayIcon ? (
        <>
          <i className="fa-solid fa-envelope ms-2" aria-hidden="true" /> {buttonText}
        </>
      ) : (
        buttonText
      )}
    </button>
  );
}

FollowupAllButton.propTypes = {
  buttonText: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.instanceOf(Object),
  ]),
  buttonClass: PropTypes.string,
  displayIcon: PropTypes.bool,
  clickEvent: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};

FollowupAllButton.defaultProps = {
  buttonText: undefined,
  buttonClass: undefined,
  displayIcon: false,
  disabled: false,
};

export default FollowupAllButton;
